import FormWithProvider from 'components/forms/form/Form';
import { CustomDataFieldType } from 'models/CustomDataField';
import { addCustomFieldSchema } from './AddCustomField.schema';
import useAddCustomFieldModalFormSubmit from './useAddCustomFieldModalFormSubmit';
import AddCustomFieldModalFormFields from './AddCustomFieldModalFormFields';

const AddCustomFieldModal = ({ modalId }: { modalId: string }) => {
  const { onSubmit } = useAddCustomFieldModalFormSubmit({ modalId });

  return (
    <FormWithProvider
      schema={addCustomFieldSchema()}
      onSubmit={onSubmit}
      horizontal
      defaultValues={{
        name: '',
        type: CustomDataFieldType.TEXT,
      }}
    >
      <AddCustomFieldModalFormFields modalId={modalId} />
    </FormWithProvider>
  );
};

export default AddCustomFieldModal;
